// source: grpc-models/Common.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.common.BrandColorModel', null, global);
goog.exportSymbol('proto.common.CheckTokenExpiryRequest', null, global);
goog.exportSymbol('proto.common.CheckTokenExpiryResponse', null, global);
goog.exportSymbol('proto.common.EstimateGenerationCreditsRequest', null, global);
goog.exportSymbol('proto.common.EstimateGenerationCreditsResponse', null, global);
goog.exportSymbol('proto.common.GetBusinessIntegrationSettingsRequest', null, global);
goog.exportSymbol('proto.common.GetBusinessIntegrationSettingsResponse', null, global);
goog.exportSymbol('proto.common.GetBusinessOnboardingDetailsRequest', null, global);
goog.exportSymbol('proto.common.GetBusinessOnboardingDetailsResponse', null, global);
goog.exportSymbol('proto.common.GetBusinessSettingsRequest', null, global);
goog.exportSymbol('proto.common.GetBusinessSettingsResponse', null, global);
goog.exportSymbol('proto.common.GetFacebookAdAccountStatusRequest', null, global);
goog.exportSymbol('proto.common.GetFacebookAdAccountStatusResponse', null, global);
goog.exportSymbol('proto.common.GetIsCouponFeatureEnabledRequest', null, global);
goog.exportSymbol('proto.common.GetIsCouponFeatureEnabledResponse', null, global);
goog.exportSymbol('proto.common.GetMetaIntegrationStatusRequest', null, global);
goog.exportSymbol('proto.common.GetMetaIntegrationStatusResponse', null, global);
goog.exportSymbol('proto.common.GetPackageStatusRequest', null, global);
goog.exportSymbol('proto.common.GetPackageStatusResponse', null, global);
goog.exportSymbol('proto.common.GetUserProfileRequest', null, global);
goog.exportSymbol('proto.common.GetUserProfileResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GetIsCouponFeatureEnabledRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.GetIsCouponFeatureEnabledRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GetIsCouponFeatureEnabledRequest.displayName = 'proto.common.GetIsCouponFeatureEnabledRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GetIsCouponFeatureEnabledResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.GetIsCouponFeatureEnabledResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GetIsCouponFeatureEnabledResponse.displayName = 'proto.common.GetIsCouponFeatureEnabledResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GetBusinessIntegrationSettingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.GetBusinessIntegrationSettingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GetBusinessIntegrationSettingsRequest.displayName = 'proto.common.GetBusinessIntegrationSettingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GetBusinessIntegrationSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.GetBusinessIntegrationSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GetBusinessIntegrationSettingsResponse.displayName = 'proto.common.GetBusinessIntegrationSettingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GetFacebookAdAccountStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.GetFacebookAdAccountStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GetFacebookAdAccountStatusRequest.displayName = 'proto.common.GetFacebookAdAccountStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GetFacebookAdAccountStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.GetFacebookAdAccountStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GetFacebookAdAccountStatusResponse.displayName = 'proto.common.GetFacebookAdAccountStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GetMetaIntegrationStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.GetMetaIntegrationStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GetMetaIntegrationStatusRequest.displayName = 'proto.common.GetMetaIntegrationStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GetMetaIntegrationStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.GetMetaIntegrationStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GetMetaIntegrationStatusResponse.displayName = 'proto.common.GetMetaIntegrationStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GetBusinessOnboardingDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.GetBusinessOnboardingDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GetBusinessOnboardingDetailsRequest.displayName = 'proto.common.GetBusinessOnboardingDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GetBusinessOnboardingDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.common.GetBusinessOnboardingDetailsResponse.repeatedFields_, null);
};
goog.inherits(proto.common.GetBusinessOnboardingDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GetBusinessOnboardingDetailsResponse.displayName = 'proto.common.GetBusinessOnboardingDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.BrandColorModel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.BrandColorModel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.BrandColorModel.displayName = 'proto.common.BrandColorModel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GetUserProfileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.GetUserProfileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GetUserProfileRequest.displayName = 'proto.common.GetUserProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GetUserProfileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.GetUserProfileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GetUserProfileResponse.displayName = 'proto.common.GetUserProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.CheckTokenExpiryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.CheckTokenExpiryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.CheckTokenExpiryRequest.displayName = 'proto.common.CheckTokenExpiryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.CheckTokenExpiryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.CheckTokenExpiryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.CheckTokenExpiryResponse.displayName = 'proto.common.CheckTokenExpiryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GetBusinessSettingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.GetBusinessSettingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GetBusinessSettingsRequest.displayName = 'proto.common.GetBusinessSettingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GetBusinessSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.GetBusinessSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GetBusinessSettingsResponse.displayName = 'proto.common.GetBusinessSettingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GetPackageStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.GetPackageStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GetPackageStatusRequest.displayName = 'proto.common.GetPackageStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GetPackageStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.GetPackageStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GetPackageStatusResponse.displayName = 'proto.common.GetPackageStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.EstimateGenerationCreditsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.EstimateGenerationCreditsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.EstimateGenerationCreditsRequest.displayName = 'proto.common.EstimateGenerationCreditsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.EstimateGenerationCreditsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.EstimateGenerationCreditsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.EstimateGenerationCreditsResponse.displayName = 'proto.common.EstimateGenerationCreditsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GetIsCouponFeatureEnabledRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GetIsCouponFeatureEnabledRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GetIsCouponFeatureEnabledRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetIsCouponFeatureEnabledRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GetIsCouponFeatureEnabledRequest}
 */
proto.common.GetIsCouponFeatureEnabledRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GetIsCouponFeatureEnabledRequest;
  return proto.common.GetIsCouponFeatureEnabledRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GetIsCouponFeatureEnabledRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GetIsCouponFeatureEnabledRequest}
 */
proto.common.GetIsCouponFeatureEnabledRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GetIsCouponFeatureEnabledRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GetIsCouponFeatureEnabledRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GetIsCouponFeatureEnabledRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetIsCouponFeatureEnabledRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GetIsCouponFeatureEnabledResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GetIsCouponFeatureEnabledResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GetIsCouponFeatureEnabledResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetIsCouponFeatureEnabledResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    iscouponfeatureenabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GetIsCouponFeatureEnabledResponse}
 */
proto.common.GetIsCouponFeatureEnabledResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GetIsCouponFeatureEnabledResponse;
  return proto.common.GetIsCouponFeatureEnabledResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GetIsCouponFeatureEnabledResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GetIsCouponFeatureEnabledResponse}
 */
proto.common.GetIsCouponFeatureEnabledResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIscouponfeatureenabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GetIsCouponFeatureEnabledResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GetIsCouponFeatureEnabledResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GetIsCouponFeatureEnabledResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetIsCouponFeatureEnabledResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIscouponfeatureenabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool isCouponFeatureEnabled = 1;
 * @return {boolean}
 */
proto.common.GetIsCouponFeatureEnabledResponse.prototype.getIscouponfeatureenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetIsCouponFeatureEnabledResponse} returns this
 */
proto.common.GetIsCouponFeatureEnabledResponse.prototype.setIscouponfeatureenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GetBusinessIntegrationSettingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GetBusinessIntegrationSettingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GetBusinessIntegrationSettingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetBusinessIntegrationSettingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GetBusinessIntegrationSettingsRequest}
 */
proto.common.GetBusinessIntegrationSettingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GetBusinessIntegrationSettingsRequest;
  return proto.common.GetBusinessIntegrationSettingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GetBusinessIntegrationSettingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GetBusinessIntegrationSettingsRequest}
 */
proto.common.GetBusinessIntegrationSettingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GetBusinessIntegrationSettingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GetBusinessIntegrationSettingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GetBusinessIntegrationSettingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetBusinessIntegrationSettingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GetBusinessIntegrationSettingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GetBusinessIntegrationSettingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetBusinessIntegrationSettingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isgoogleconnected: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    isstripeconnected: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    isauthorizeconnected: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    isfacebookconnected: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    isinstagramconnected: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    ismetamessagessyncing: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    facebookpagename: (f = msg.getFacebookpagename()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    instagramaccountname: (f = msg.getInstagramaccountname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    isbusinessportfolioconnected: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    isfacebookvideosavailable: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    isinstagramvideosavailable: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    isleadformavailable: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    iscustomaudiencetosaccepted: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    customaudiencetoslink: (f = msg.getCustomaudiencetoslink()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    adaccountname: (f = msg.getAdaccountname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    instagramusername: (f = msg.getInstagramusername()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    adaccountid: (f = msg.getAdaccountid()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse}
 */
proto.common.GetBusinessIntegrationSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GetBusinessIntegrationSettingsResponse;
  return proto.common.GetBusinessIntegrationSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GetBusinessIntegrationSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse}
 */
proto.common.GetBusinessIntegrationSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsgoogleconnected(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsstripeconnected(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsauthorizeconnected(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsfacebookconnected(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsinstagramconnected(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsmetamessagessyncing(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setFacebookpagename(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setInstagramaccountname(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsbusinessportfolioconnected(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsfacebookvideosavailable(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsinstagramvideosavailable(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsleadformavailable(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIscustomaudiencetosaccepted(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomaudiencetoslink(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAdaccountname(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setInstagramusername(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAdaccountid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GetBusinessIntegrationSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GetBusinessIntegrationSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetBusinessIntegrationSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsgoogleconnected();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getIsstripeconnected();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getIsauthorizeconnected();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getIsfacebookconnected();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getIsinstagramconnected();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getIsmetamessagessyncing();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getFacebookpagename();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getInstagramaccountname();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIsbusinessportfolioconnected();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getIsfacebookvideosavailable();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getIsinstagramvideosavailable();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getIsleadformavailable();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getIscustomaudiencetosaccepted();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getCustomaudiencetoslink();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAdaccountname();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getInstagramusername();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAdaccountid();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool isGoogleConnected = 1;
 * @return {boolean}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.getIsgoogleconnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.setIsgoogleconnected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool isStripeConnected = 2;
 * @return {boolean}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.getIsstripeconnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.setIsstripeconnected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool isAuthorizeConnected = 3;
 * @return {boolean}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.getIsauthorizeconnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.setIsauthorizeconnected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool isFacebookConnected = 4;
 * @return {boolean}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.getIsfacebookconnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.setIsfacebookconnected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool isInstagramConnected = 5;
 * @return {boolean}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.getIsinstagramconnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.setIsinstagramconnected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool isMetaMessagesSyncing = 6;
 * @return {boolean}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.getIsmetamessagessyncing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.setIsmetamessagessyncing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional google.protobuf.StringValue facebookPageName = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.getFacebookpagename = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
*/
proto.common.GetBusinessIntegrationSettingsResponse.prototype.setFacebookpagename = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.clearFacebookpagename = function() {
  return this.setFacebookpagename(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.hasFacebookpagename = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue instagramAccountName = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.getInstagramaccountname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
*/
proto.common.GetBusinessIntegrationSettingsResponse.prototype.setInstagramaccountname = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.clearInstagramaccountname = function() {
  return this.setInstagramaccountname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.hasInstagramaccountname = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool isBusinessPortfolioConnected = 9;
 * @return {boolean}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.getIsbusinessportfolioconnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.setIsbusinessportfolioconnected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool isFacebookVideosAvailable = 10;
 * @return {boolean}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.getIsfacebookvideosavailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.setIsfacebookvideosavailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool isInstagramVideosAvailable = 11;
 * @return {boolean}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.getIsinstagramvideosavailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.setIsinstagramvideosavailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool isLeadFormAvailable = 12;
 * @return {boolean}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.getIsleadformavailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.setIsleadformavailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool isCustomAudienceTosAccepted = 13;
 * @return {boolean}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.getIscustomaudiencetosaccepted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.setIscustomaudiencetosaccepted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional google.protobuf.StringValue customAudienceTOSLink = 14;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.getCustomaudiencetoslink = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 14));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
*/
proto.common.GetBusinessIntegrationSettingsResponse.prototype.setCustomaudiencetoslink = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.clearCustomaudiencetoslink = function() {
  return this.setCustomaudiencetoslink(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.hasCustomaudiencetoslink = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.StringValue adAccountName = 15;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.getAdaccountname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
*/
proto.common.GetBusinessIntegrationSettingsResponse.prototype.setAdaccountname = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.clearAdaccountname = function() {
  return this.setAdaccountname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.hasAdaccountname = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.StringValue instagramUserName = 16;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.getInstagramusername = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 16));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
*/
proto.common.GetBusinessIntegrationSettingsResponse.prototype.setInstagramusername = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.clearInstagramusername = function() {
  return this.setInstagramusername(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.hasInstagramusername = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.StringValue adAccountId = 17;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.getAdaccountid = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 17));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
*/
proto.common.GetBusinessIntegrationSettingsResponse.prototype.setAdaccountid = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessIntegrationSettingsResponse} returns this
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.clearAdaccountid = function() {
  return this.setAdaccountid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessIntegrationSettingsResponse.prototype.hasAdaccountid = function() {
  return jspb.Message.getField(this, 17) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GetFacebookAdAccountStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GetFacebookAdAccountStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GetFacebookAdAccountStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetFacebookAdAccountStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GetFacebookAdAccountStatusRequest}
 */
proto.common.GetFacebookAdAccountStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GetFacebookAdAccountStatusRequest;
  return proto.common.GetFacebookAdAccountStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GetFacebookAdAccountStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GetFacebookAdAccountStatusRequest}
 */
proto.common.GetFacebookAdAccountStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GetFacebookAdAccountStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GetFacebookAdAccountStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GetFacebookAdAccountStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetFacebookAdAccountStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GetFacebookAdAccountStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GetFacebookAdAccountStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GetFacebookAdAccountStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetFacebookAdAccountStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountstatus: jspb.Message.getFieldWithDefault(msg, 1, 0),
    ispaymentmethodconnected: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GetFacebookAdAccountStatusResponse}
 */
proto.common.GetFacebookAdAccountStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GetFacebookAdAccountStatusResponse;
  return proto.common.GetFacebookAdAccountStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GetFacebookAdAccountStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GetFacebookAdAccountStatusResponse}
 */
proto.common.GetFacebookAdAccountStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAccountstatus(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIspaymentmethodconnected(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GetFacebookAdAccountStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GetFacebookAdAccountStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GetFacebookAdAccountStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetFacebookAdAccountStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountstatus();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getIspaymentmethodconnected();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional int32 accountStatus = 1;
 * @return {number}
 */
proto.common.GetFacebookAdAccountStatusResponse.prototype.getAccountstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetFacebookAdAccountStatusResponse} returns this
 */
proto.common.GetFacebookAdAccountStatusResponse.prototype.setAccountstatus = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool isPaymentMethodConnected = 2;
 * @return {boolean}
 */
proto.common.GetFacebookAdAccountStatusResponse.prototype.getIspaymentmethodconnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetFacebookAdAccountStatusResponse} returns this
 */
proto.common.GetFacebookAdAccountStatusResponse.prototype.setIspaymentmethodconnected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GetMetaIntegrationStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GetMetaIntegrationStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GetMetaIntegrationStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetMetaIntegrationStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    businessid: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GetMetaIntegrationStatusRequest}
 */
proto.common.GetMetaIntegrationStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GetMetaIntegrationStatusRequest;
  return proto.common.GetMetaIntegrationStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GetMetaIntegrationStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GetMetaIntegrationStatusRequest}
 */
proto.common.GetMetaIntegrationStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBusinessid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GetMetaIntegrationStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GetMetaIntegrationStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GetMetaIntegrationStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetMetaIntegrationStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBusinessid();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 businessId = 1;
 * @return {number}
 */
proto.common.GetMetaIntegrationStatusRequest.prototype.getBusinessid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetMetaIntegrationStatusRequest} returns this
 */
proto.common.GetMetaIntegrationStatusRequest.prototype.setBusinessid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GetMetaIntegrationStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GetMetaIntegrationStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GetMetaIntegrationStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetMetaIntegrationStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isaccesstokenvalid: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    isactiveintegrationexist: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GetMetaIntegrationStatusResponse}
 */
proto.common.GetMetaIntegrationStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GetMetaIntegrationStatusResponse;
  return proto.common.GetMetaIntegrationStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GetMetaIntegrationStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GetMetaIntegrationStatusResponse}
 */
proto.common.GetMetaIntegrationStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsaccesstokenvalid(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsactiveintegrationexist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GetMetaIntegrationStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GetMetaIntegrationStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GetMetaIntegrationStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetMetaIntegrationStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsaccesstokenvalid();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getIsactiveintegrationexist();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional bool isAccessTokenValid = 1;
 * @return {boolean}
 */
proto.common.GetMetaIntegrationStatusResponse.prototype.getIsaccesstokenvalid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetMetaIntegrationStatusResponse} returns this
 */
proto.common.GetMetaIntegrationStatusResponse.prototype.setIsaccesstokenvalid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool isActiveIntegrationExist = 2;
 * @return {boolean}
 */
proto.common.GetMetaIntegrationStatusResponse.prototype.getIsactiveintegrationexist = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetMetaIntegrationStatusResponse} returns this
 */
proto.common.GetMetaIntegrationStatusResponse.prototype.setIsactiveintegrationexist = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GetBusinessOnboardingDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GetBusinessOnboardingDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GetBusinessOnboardingDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetBusinessOnboardingDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    businessid: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GetBusinessOnboardingDetailsRequest}
 */
proto.common.GetBusinessOnboardingDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GetBusinessOnboardingDetailsRequest;
  return proto.common.GetBusinessOnboardingDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GetBusinessOnboardingDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GetBusinessOnboardingDetailsRequest}
 */
proto.common.GetBusinessOnboardingDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBusinessid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GetBusinessOnboardingDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GetBusinessOnboardingDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GetBusinessOnboardingDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetBusinessOnboardingDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBusinessid();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 businessId = 1;
 * @return {number}
 */
proto.common.GetBusinessOnboardingDetailsRequest.prototype.getBusinessid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetBusinessOnboardingDetailsRequest} returns this
 */
proto.common.GetBusinessOnboardingDetailsRequest.prototype.setBusinessid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.common.GetBusinessOnboardingDetailsResponse.repeatedFields_ = [16];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GetBusinessOnboardingDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GetBusinessOnboardingDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetBusinessOnboardingDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    businesscategoryid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pricetierid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    businessusp: (f = msg.getBusinessusp()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    businesscategoryname: (f = msg.getBusinesscategoryname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    isonboardingcompleted: (f = msg.getIsonboardingcompleted()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    websiteurl: (f = msg.getWebsiteurl()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    businessname: (f = msg.getBusinessname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    businesstypeid: jspb.Message.getFieldWithDefault(msg, 9, 0),
    phonenumber: (f = msg.getPhonenumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    address: (f = msg.getAddress()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    city: (f = msg.getCity()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    state: (f = msg.getState()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    scraperdjson: jspb.Message.getFieldWithDefault(msg, 14, ""),
    isscrapingcompleted: (f = msg.getIsscrapingcompleted()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    brandcolorsList: jspb.Message.toObjectList(msg.getBrandcolorsList(),
    proto.common.BrandColorModel.toObject, includeInstance),
    businessLogoUrl: jspb.Message.getFieldWithDefault(msg, 17, ""),
    segment: jspb.Message.getFieldWithDefault(msg, 18, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse}
 */
proto.common.GetBusinessOnboardingDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GetBusinessOnboardingDetailsResponse;
  return proto.common.GetBusinessOnboardingDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GetBusinessOnboardingDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse}
 */
proto.common.GetBusinessOnboardingDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBusinesscategoryid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPricetierid(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBusinessusp(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBusinesscategoryname(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsonboardingcompleted(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setWebsiteurl(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBusinessname(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBusinesstypeid(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPhonenumber(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddress(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCity(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setState(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setScraperdjson(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsscrapingcompleted(value);
      break;
    case 16:
      var value = new proto.common.BrandColorModel;
      reader.readMessage(value,proto.common.BrandColorModel.deserializeBinaryFromReader);
      msg.addBrandcolors(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessLogoUrl(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setSegment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GetBusinessOnboardingDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GetBusinessOnboardingDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetBusinessOnboardingDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getBusinesscategoryid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPricetierid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getBusinessusp();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBusinesscategoryname();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIsonboardingcompleted();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getWebsiteurl();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBusinessname();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBusinesstypeid();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getPhonenumber();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAddress();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCity();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getState();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getScraperdjson();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getIsscrapingcompleted();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getBrandcolorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      proto.common.BrandColorModel.serializeBinaryToWriter
    );
  }
  f = message.getBusinessLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getSegment();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 businessCategoryId = 2;
 * @return {number}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getBusinesscategoryid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setBusinesscategoryid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 priceTierId = 3;
 * @return {number}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getPricetierid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setPricetierid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue businessUsp = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getBusinessusp = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setBusinessusp = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.clearBusinessusp = function() {
  return this.setBusinessusp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.hasBusinessusp = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue businessCategoryName = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getBusinesscategoryname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setBusinesscategoryname = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.clearBusinesscategoryname = function() {
  return this.setBusinesscategoryname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.hasBusinesscategoryname = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.BoolValue isOnboardingCompleted = 6;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getIsonboardingcompleted = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 6));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setIsonboardingcompleted = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.clearIsonboardingcompleted = function() {
  return this.setIsonboardingcompleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.hasIsonboardingcompleted = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue websiteUrl = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getWebsiteurl = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setWebsiteurl = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.clearWebsiteurl = function() {
  return this.setWebsiteurl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.hasWebsiteurl = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue businessName = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getBusinessname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setBusinessname = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.clearBusinessname = function() {
  return this.setBusinessname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.hasBusinessname = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional int32 businessTypeId = 9;
 * @return {number}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getBusinesstypeid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setBusinesstypeid = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional google.protobuf.StringValue phoneNumber = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getPhonenumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setPhonenumber = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.clearPhonenumber = function() {
  return this.setPhonenumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.hasPhonenumber = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.StringValue address = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getAddress = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setAddress = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.clearAddress = function() {
  return this.setAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.hasAddress = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue city = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getCity = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setCity = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.clearCity = function() {
  return this.setCity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.hasCity = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.StringValue state = 13;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getState = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 13));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setState = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.clearState = function() {
  return this.setState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.hasState = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string scraperdJson = 14;
 * @return {string}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getScraperdjson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setScraperdjson = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional google.protobuf.BoolValue isScrapingCompleted = 15;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getIsscrapingcompleted = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 15));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setIsscrapingcompleted = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.clearIsscrapingcompleted = function() {
  return this.setIsscrapingcompleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.hasIsscrapingcompleted = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * repeated BrandColorModel brandColors = 16;
 * @return {!Array<!proto.common.BrandColorModel>}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getBrandcolorsList = function() {
  return /** @type{!Array<!proto.common.BrandColorModel>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.common.BrandColorModel, 16));
};


/**
 * @param {!Array<!proto.common.BrandColorModel>} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
*/
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setBrandcolorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.common.BrandColorModel=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.BrandColorModel}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.addBrandcolors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.common.BrandColorModel, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.clearBrandcolorsList = function() {
  return this.setBrandcolorsList([]);
};


/**
 * optional string business_logo_url = 17;
 * @return {string}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getBusinessLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setBusinessLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string segment = 18;
 * @return {string}
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.getSegment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.GetBusinessOnboardingDetailsResponse} returns this
 */
proto.common.GetBusinessOnboardingDetailsResponse.prototype.setSegment = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.BrandColorModel.prototype.toObject = function(opt_includeInstance) {
  return proto.common.BrandColorModel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.BrandColorModel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.BrandColorModel.toObject = function(includeInstance, msg) {
  var f, obj = {
    rank: jspb.Message.getFieldWithDefault(msg, 1, 0),
    color: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isscrapped: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.BrandColorModel}
 */
proto.common.BrandColorModel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.BrandColorModel;
  return proto.common.BrandColorModel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.BrandColorModel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.BrandColorModel}
 */
proto.common.BrandColorModel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRank(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsscrapped(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.BrandColorModel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.BrandColorModel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.BrandColorModel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.BrandColorModel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsscrapped();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional int32 rank = 1;
 * @return {number}
 */
proto.common.BrandColorModel.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.BrandColorModel} returns this
 */
proto.common.BrandColorModel.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string color = 2;
 * @return {string}
 */
proto.common.BrandColorModel.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.BrandColorModel} returns this
 */
proto.common.BrandColorModel.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool isScrapped = 3;
 * @return {boolean}
 */
proto.common.BrandColorModel.prototype.getIsscrapped = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.BrandColorModel} returns this
 */
proto.common.BrandColorModel.prototype.setIsscrapped = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GetUserProfileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GetUserProfileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GetUserProfileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetUserProfileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GetUserProfileRequest}
 */
proto.common.GetUserProfileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GetUserProfileRequest;
  return proto.common.GetUserProfileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GetUserProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GetUserProfileRequest}
 */
proto.common.GetUserProfileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GetUserProfileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GetUserProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GetUserProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetUserProfileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GetUserProfileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GetUserProfileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GetUserProfileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetUserProfileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    firstname: (f = msg.getFirstname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    lastname: (f = msg.getLastname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    email: (f = msg.getEmail()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    isgoogleuser: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    isomsuser: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    omsorderguid: (f = msg.getOmsorderguid()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    isfacebookuser: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GetUserProfileResponse}
 */
proto.common.GetUserProfileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GetUserProfileResponse;
  return proto.common.GetUserProfileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GetUserProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GetUserProfileResponse}
 */
proto.common.GetUserProfileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setFirstname(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLastname(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsgoogleuser(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsomsuser(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOmsorderguid(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsfacebookuser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GetUserProfileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GetUserProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GetUserProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetUserProfileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirstname();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLastname();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEmail();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIsgoogleuser();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getIsomsuser();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getOmsorderguid();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIsfacebookuser();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional google.protobuf.StringValue firstName = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetUserProfileResponse.prototype.getFirstname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetUserProfileResponse} returns this
*/
proto.common.GetUserProfileResponse.prototype.setFirstname = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetUserProfileResponse} returns this
 */
proto.common.GetUserProfileResponse.prototype.clearFirstname = function() {
  return this.setFirstname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetUserProfileResponse.prototype.hasFirstname = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue lastName = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetUserProfileResponse.prototype.getLastname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetUserProfileResponse} returns this
*/
proto.common.GetUserProfileResponse.prototype.setLastname = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetUserProfileResponse} returns this
 */
proto.common.GetUserProfileResponse.prototype.clearLastname = function() {
  return this.setLastname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetUserProfileResponse.prototype.hasLastname = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue email = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetUserProfileResponse.prototype.getEmail = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetUserProfileResponse} returns this
*/
proto.common.GetUserProfileResponse.prototype.setEmail = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetUserProfileResponse} returns this
 */
proto.common.GetUserProfileResponse.prototype.clearEmail = function() {
  return this.setEmail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetUserProfileResponse.prototype.hasEmail = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool isGoogleUser = 4;
 * @return {boolean}
 */
proto.common.GetUserProfileResponse.prototype.getIsgoogleuser = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetUserProfileResponse} returns this
 */
proto.common.GetUserProfileResponse.prototype.setIsgoogleuser = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool isOmsUser = 5;
 * @return {boolean}
 */
proto.common.GetUserProfileResponse.prototype.getIsomsuser = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetUserProfileResponse} returns this
 */
proto.common.GetUserProfileResponse.prototype.setIsomsuser = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional google.protobuf.StringValue omsOrderGuid = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetUserProfileResponse.prototype.getOmsorderguid = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetUserProfileResponse} returns this
*/
proto.common.GetUserProfileResponse.prototype.setOmsorderguid = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetUserProfileResponse} returns this
 */
proto.common.GetUserProfileResponse.prototype.clearOmsorderguid = function() {
  return this.setOmsorderguid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetUserProfileResponse.prototype.hasOmsorderguid = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool isFacebookUser = 7;
 * @return {boolean}
 */
proto.common.GetUserProfileResponse.prototype.getIsfacebookuser = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetUserProfileResponse} returns this
 */
proto.common.GetUserProfileResponse.prototype.setIsfacebookuser = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.CheckTokenExpiryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.common.CheckTokenExpiryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.CheckTokenExpiryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.CheckTokenExpiryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.CheckTokenExpiryRequest}
 */
proto.common.CheckTokenExpiryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.CheckTokenExpiryRequest;
  return proto.common.CheckTokenExpiryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.CheckTokenExpiryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.CheckTokenExpiryRequest}
 */
proto.common.CheckTokenExpiryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.CheckTokenExpiryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.CheckTokenExpiryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.CheckTokenExpiryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.CheckTokenExpiryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.common.CheckTokenExpiryRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.CheckTokenExpiryRequest} returns this
 */
proto.common.CheckTokenExpiryRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.CheckTokenExpiryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.common.CheckTokenExpiryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.CheckTokenExpiryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.CheckTokenExpiryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isexpired: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.CheckTokenExpiryResponse}
 */
proto.common.CheckTokenExpiryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.CheckTokenExpiryResponse;
  return proto.common.CheckTokenExpiryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.CheckTokenExpiryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.CheckTokenExpiryResponse}
 */
proto.common.CheckTokenExpiryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsexpired(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.CheckTokenExpiryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.CheckTokenExpiryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.CheckTokenExpiryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.CheckTokenExpiryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsexpired();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool isExpired = 1;
 * @return {boolean}
 */
proto.common.CheckTokenExpiryResponse.prototype.getIsexpired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.CheckTokenExpiryResponse} returns this
 */
proto.common.CheckTokenExpiryResponse.prototype.setIsexpired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GetBusinessSettingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GetBusinessSettingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GetBusinessSettingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetBusinessSettingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GetBusinessSettingsRequest}
 */
proto.common.GetBusinessSettingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GetBusinessSettingsRequest;
  return proto.common.GetBusinessSettingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GetBusinessSettingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GetBusinessSettingsRequest}
 */
proto.common.GetBusinessSettingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GetBusinessSettingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GetBusinessSettingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GetBusinessSettingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetBusinessSettingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GetBusinessSettingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GetBusinessSettingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GetBusinessSettingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetBusinessSettingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    invoiceprefix: (f = msg.getInvoiceprefix()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    isarchivenotificationenabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    bookingexternallink: (f = msg.getBookingexternallink()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    isonboardingcompleted: (f = msg.getIsonboardingcompleted()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    isonboardingbusinessdetailcompleted: (f = msg.getIsonboardingbusinessdetailcompleted()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    isonboardingbusinessservicecompleted: (f = msg.getIsonboardingbusinessservicecompleted()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    businessid: jspb.Message.getFieldWithDefault(msg, 7, 0),
    timezoneoffset: (f = msg.getTimezoneoffset()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
    istestbusiness: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    isreferraluser: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    aistaticcreativegetstartedcount: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GetBusinessSettingsResponse}
 */
proto.common.GetBusinessSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GetBusinessSettingsResponse;
  return proto.common.GetBusinessSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GetBusinessSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GetBusinessSettingsResponse}
 */
proto.common.GetBusinessSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setInvoiceprefix(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsarchivenotificationenabled(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBookingexternallink(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsonboardingcompleted(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsonboardingbusinessdetailcompleted(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsonboardingbusinessservicecompleted(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBusinessid(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTimezoneoffset(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIstestbusiness(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsreferraluser(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAistaticcreativegetstartedcount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GetBusinessSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GetBusinessSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GetBusinessSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetBusinessSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvoiceprefix();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIsarchivenotificationenabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getBookingexternallink();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIsonboardingcompleted();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getIsonboardingbusinessdetailcompleted();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getIsonboardingbusinessservicecompleted();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getBusinessid();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getTimezoneoffset();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getIstestbusiness();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getIsreferraluser();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getAistaticcreativegetstartedcount();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
};


/**
 * optional google.protobuf.StringValue invoicePrefix = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetBusinessSettingsResponse.prototype.getInvoiceprefix = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetBusinessSettingsResponse} returns this
*/
proto.common.GetBusinessSettingsResponse.prototype.setInvoiceprefix = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessSettingsResponse} returns this
 */
proto.common.GetBusinessSettingsResponse.prototype.clearInvoiceprefix = function() {
  return this.setInvoiceprefix(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessSettingsResponse.prototype.hasInvoiceprefix = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool isArchiveNotificationEnabled = 2;
 * @return {boolean}
 */
proto.common.GetBusinessSettingsResponse.prototype.getIsarchivenotificationenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetBusinessSettingsResponse} returns this
 */
proto.common.GetBusinessSettingsResponse.prototype.setIsarchivenotificationenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue bookingExternalLink = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetBusinessSettingsResponse.prototype.getBookingexternallink = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetBusinessSettingsResponse} returns this
*/
proto.common.GetBusinessSettingsResponse.prototype.setBookingexternallink = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessSettingsResponse} returns this
 */
proto.common.GetBusinessSettingsResponse.prototype.clearBookingexternallink = function() {
  return this.setBookingexternallink(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessSettingsResponse.prototype.hasBookingexternallink = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.BoolValue isOnboardingCompleted = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.common.GetBusinessSettingsResponse.prototype.getIsonboardingcompleted = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.common.GetBusinessSettingsResponse} returns this
*/
proto.common.GetBusinessSettingsResponse.prototype.setIsonboardingcompleted = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessSettingsResponse} returns this
 */
proto.common.GetBusinessSettingsResponse.prototype.clearIsonboardingcompleted = function() {
  return this.setIsonboardingcompleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessSettingsResponse.prototype.hasIsonboardingcompleted = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.BoolValue isOnboardingBusinessDetailCompleted = 5;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.common.GetBusinessSettingsResponse.prototype.getIsonboardingbusinessdetailcompleted = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 5));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.common.GetBusinessSettingsResponse} returns this
*/
proto.common.GetBusinessSettingsResponse.prototype.setIsonboardingbusinessdetailcompleted = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessSettingsResponse} returns this
 */
proto.common.GetBusinessSettingsResponse.prototype.clearIsonboardingbusinessdetailcompleted = function() {
  return this.setIsonboardingbusinessdetailcompleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessSettingsResponse.prototype.hasIsonboardingbusinessdetailcompleted = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.BoolValue isOnboardingBusinessServiceCompleted = 6;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.common.GetBusinessSettingsResponse.prototype.getIsonboardingbusinessservicecompleted = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 6));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.common.GetBusinessSettingsResponse} returns this
*/
proto.common.GetBusinessSettingsResponse.prototype.setIsonboardingbusinessservicecompleted = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessSettingsResponse} returns this
 */
proto.common.GetBusinessSettingsResponse.prototype.clearIsonboardingbusinessservicecompleted = function() {
  return this.setIsonboardingbusinessservicecompleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessSettingsResponse.prototype.hasIsonboardingbusinessservicecompleted = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int64 businessId = 7;
 * @return {number}
 */
proto.common.GetBusinessSettingsResponse.prototype.getBusinessid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetBusinessSettingsResponse} returns this
 */
proto.common.GetBusinessSettingsResponse.prototype.setBusinessid = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional google.protobuf.DoubleValue timezoneOffset = 8;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.common.GetBusinessSettingsResponse.prototype.getTimezoneoffset = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 8));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.common.GetBusinessSettingsResponse} returns this
*/
proto.common.GetBusinessSettingsResponse.prototype.setTimezoneoffset = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetBusinessSettingsResponse} returns this
 */
proto.common.GetBusinessSettingsResponse.prototype.clearTimezoneoffset = function() {
  return this.setTimezoneoffset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetBusinessSettingsResponse.prototype.hasTimezoneoffset = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool isTestBusiness = 9;
 * @return {boolean}
 */
proto.common.GetBusinessSettingsResponse.prototype.getIstestbusiness = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetBusinessSettingsResponse} returns this
 */
proto.common.GetBusinessSettingsResponse.prototype.setIstestbusiness = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool isReferralUser = 10;
 * @return {boolean}
 */
proto.common.GetBusinessSettingsResponse.prototype.getIsreferraluser = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetBusinessSettingsResponse} returns this
 */
proto.common.GetBusinessSettingsResponse.prototype.setIsreferraluser = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional int32 aiStaticCreativeGetStartedCount = 11;
 * @return {number}
 */
proto.common.GetBusinessSettingsResponse.prototype.getAistaticcreativegetstartedcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetBusinessSettingsResponse} returns this
 */
proto.common.GetBusinessSettingsResponse.prototype.setAistaticcreativegetstartedcount = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GetPackageStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GetPackageStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GetPackageStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetPackageStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GetPackageStatusRequest}
 */
proto.common.GetPackageStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GetPackageStatusRequest;
  return proto.common.GetPackageStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GetPackageStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GetPackageStatusRequest}
 */
proto.common.GetPackageStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GetPackageStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GetPackageStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GetPackageStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetPackageStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GetPackageStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GetPackageStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GetPackageStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetPackageStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    ispackageexpired: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    isfreemiumpackage: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    istrialpackage: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    trialpackagedays: jspb.Message.getFieldWithDefault(msg, 4, 0),
    istrialextended: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    extendedtrialdays: jspb.Message.getFieldWithDefault(msg, 6, 0),
    remainingextendedtrialdays: jspb.Message.getFieldWithDefault(msg, 7, 0),
    isextendedtrialended: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    packagename: (f = msg.getPackagename()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    subscriptionendsondate: (f = msg.getSubscriptionendsondate()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    iscancelationrequested: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    issubscriptioncanceled: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    billingid: jspb.Message.getFieldWithDefault(msg, 13, 0),
    ispaymentrefunded: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    packageid: jspb.Message.getFieldWithDefault(msg, 15, 0),
    ugcavatarlimit: jspb.Message.getFieldWithDefault(msg, 16, 0),
    monthlyavatarlimit: jspb.Message.getFieldWithDefault(msg, 17, 0),
    staticcreativelimit: jspb.Message.getFieldWithDefault(msg, 18, 0),
    monthlystaticcreativelimit: jspb.Message.getFieldWithDefault(msg, 19, 0),
    aistaticcreativelimit: jspb.Message.getFieldWithDefault(msg, 20, 0),
    aistaticcreativerevisionlimit: jspb.Message.getFieldWithDefault(msg, 21, 0),
    totalaistaticcreatives: jspb.Message.getFieldWithDefault(msg, 22, 0),
    generatedaistaticcreatives: jspb.Message.getFieldWithDefault(msg, 23, 0),
    ugcvoiceoverlimit: jspb.Message.getFieldWithDefault(msg, 24, 0),
    monthlyvoiceoverlimit: jspb.Message.getFieldWithDefault(msg, 25, 0),
    plancredits: jspb.Message.getFieldWithDefault(msg, 26, 0),
    addoncredits: jspb.Message.getFieldWithDefault(msg, 27, 0),
    isaddonpurchased: jspb.Message.getBooleanFieldWithDefault(msg, 28, false),
    ispaused: jspb.Message.getBooleanFieldWithDefault(msg, 29, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GetPackageStatusResponse}
 */
proto.common.GetPackageStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GetPackageStatusResponse;
  return proto.common.GetPackageStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GetPackageStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GetPackageStatusResponse}
 */
proto.common.GetPackageStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIspackageexpired(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsfreemiumpackage(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIstrialpackage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrialpackagedays(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIstrialextended(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExtendedtrialdays(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRemainingextendedtrialdays(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsextendedtrialended(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPackagename(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSubscriptionendsondate(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIscancelationrequested(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIssubscriptioncanceled(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBillingid(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIspaymentrefunded(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPackageid(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUgcavatarlimit(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMonthlyavatarlimit(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStaticcreativelimit(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMonthlystaticcreativelimit(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAistaticcreativelimit(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAistaticcreativerevisionlimit(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalaistaticcreatives(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGeneratedaistaticcreatives(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUgcvoiceoverlimit(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMonthlyvoiceoverlimit(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlancredits(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAddoncredits(value);
      break;
    case 28:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsaddonpurchased(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIspaused(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GetPackageStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GetPackageStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GetPackageStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GetPackageStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIspackageexpired();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getIsfreemiumpackage();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getIstrialpackage();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTrialpackagedays();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getIstrialextended();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getExtendedtrialdays();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getRemainingextendedtrialdays();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getIsextendedtrialended();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getPackagename();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSubscriptionendsondate();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIscancelationrequested();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getIssubscriptioncanceled();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getBillingid();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getIspaymentrefunded();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getPackageid();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getUgcavatarlimit();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getMonthlyavatarlimit();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getStaticcreativelimit();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getMonthlystaticcreativelimit();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getAistaticcreativelimit();
  if (f !== 0) {
    writer.writeInt32(
      20,
      f
    );
  }
  f = message.getAistaticcreativerevisionlimit();
  if (f !== 0) {
    writer.writeInt32(
      21,
      f
    );
  }
  f = message.getTotalaistaticcreatives();
  if (f !== 0) {
    writer.writeInt32(
      22,
      f
    );
  }
  f = message.getGeneratedaistaticcreatives();
  if (f !== 0) {
    writer.writeInt32(
      23,
      f
    );
  }
  f = message.getUgcvoiceoverlimit();
  if (f !== 0) {
    writer.writeInt32(
      24,
      f
    );
  }
  f = message.getMonthlyvoiceoverlimit();
  if (f !== 0) {
    writer.writeInt32(
      25,
      f
    );
  }
  f = message.getPlancredits();
  if (f !== 0) {
    writer.writeInt32(
      26,
      f
    );
  }
  f = message.getAddoncredits();
  if (f !== 0) {
    writer.writeInt32(
      27,
      f
    );
  }
  f = message.getIsaddonpurchased();
  if (f) {
    writer.writeBool(
      28,
      f
    );
  }
  f = message.getIspaused();
  if (f) {
    writer.writeBool(
      29,
      f
    );
  }
};


/**
 * optional bool isPackageExpired = 1;
 * @return {boolean}
 */
proto.common.GetPackageStatusResponse.prototype.getIspackageexpired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setIspackageexpired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool isFreemiumPackage = 2;
 * @return {boolean}
 */
proto.common.GetPackageStatusResponse.prototype.getIsfreemiumpackage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setIsfreemiumpackage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool isTrialPackage = 3;
 * @return {boolean}
 */
proto.common.GetPackageStatusResponse.prototype.getIstrialpackage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setIstrialpackage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional int32 trialPackageDays = 4;
 * @return {number}
 */
proto.common.GetPackageStatusResponse.prototype.getTrialpackagedays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setTrialpackagedays = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool isTrialExtended = 5;
 * @return {boolean}
 */
proto.common.GetPackageStatusResponse.prototype.getIstrialextended = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setIstrialextended = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional int32 extendedTrialDays = 6;
 * @return {number}
 */
proto.common.GetPackageStatusResponse.prototype.getExtendedtrialdays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setExtendedtrialdays = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 remainingExtendedTrialDays = 7;
 * @return {number}
 */
proto.common.GetPackageStatusResponse.prototype.getRemainingextendedtrialdays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setRemainingextendedtrialdays = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional bool isExtendedTrialEnded = 8;
 * @return {boolean}
 */
proto.common.GetPackageStatusResponse.prototype.getIsextendedtrialended = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setIsextendedtrialended = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional google.protobuf.StringValue packageName = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetPackageStatusResponse.prototype.getPackagename = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
*/
proto.common.GetPackageStatusResponse.prototype.setPackagename = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.clearPackagename = function() {
  return this.setPackagename(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetPackageStatusResponse.prototype.hasPackagename = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.StringValue subscriptionEndsOnDate = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.common.GetPackageStatusResponse.prototype.getSubscriptionendsondate = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
*/
proto.common.GetPackageStatusResponse.prototype.setSubscriptionendsondate = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.clearSubscriptionendsondate = function() {
  return this.setSubscriptionendsondate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GetPackageStatusResponse.prototype.hasSubscriptionendsondate = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional bool isCancelationRequested = 11;
 * @return {boolean}
 */
proto.common.GetPackageStatusResponse.prototype.getIscancelationrequested = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setIscancelationrequested = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool isSubscriptionCanceled = 12;
 * @return {boolean}
 */
proto.common.GetPackageStatusResponse.prototype.getIssubscriptioncanceled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setIssubscriptioncanceled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional int64 billingId = 13;
 * @return {number}
 */
proto.common.GetPackageStatusResponse.prototype.getBillingid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setBillingid = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional bool isPaymentRefunded = 14;
 * @return {boolean}
 */
proto.common.GetPackageStatusResponse.prototype.getIspaymentrefunded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setIspaymentrefunded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional int32 packageId = 15;
 * @return {number}
 */
proto.common.GetPackageStatusResponse.prototype.getPackageid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setPackageid = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int32 ugcAvatarLimit = 16;
 * @return {number}
 */
proto.common.GetPackageStatusResponse.prototype.getUgcavatarlimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setUgcavatarlimit = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 monthlyAvatarLimit = 17;
 * @return {number}
 */
proto.common.GetPackageStatusResponse.prototype.getMonthlyavatarlimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setMonthlyavatarlimit = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int32 staticCreativeLimit = 18;
 * @return {number}
 */
proto.common.GetPackageStatusResponse.prototype.getStaticcreativelimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setStaticcreativelimit = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int32 monthlyStaticCreativeLimit = 19;
 * @return {number}
 */
proto.common.GetPackageStatusResponse.prototype.getMonthlystaticcreativelimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setMonthlystaticcreativelimit = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int32 aiStaticCreativeLimit = 20;
 * @return {number}
 */
proto.common.GetPackageStatusResponse.prototype.getAistaticcreativelimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setAistaticcreativelimit = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int32 aiStaticCreativeRevisionLimit = 21;
 * @return {number}
 */
proto.common.GetPackageStatusResponse.prototype.getAistaticcreativerevisionlimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setAistaticcreativerevisionlimit = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional int32 totalAIStaticCreatives = 22;
 * @return {number}
 */
proto.common.GetPackageStatusResponse.prototype.getTotalaistaticcreatives = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setTotalaistaticcreatives = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional int32 generatedAIStaticCreatives = 23;
 * @return {number}
 */
proto.common.GetPackageStatusResponse.prototype.getGeneratedaistaticcreatives = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setGeneratedaistaticcreatives = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional int32 ugcVoiceoverLimit = 24;
 * @return {number}
 */
proto.common.GetPackageStatusResponse.prototype.getUgcvoiceoverlimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setUgcvoiceoverlimit = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int32 monthlyVoiceoverLimit = 25;
 * @return {number}
 */
proto.common.GetPackageStatusResponse.prototype.getMonthlyvoiceoverlimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setMonthlyvoiceoverlimit = function(value) {
  return jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional int32 planCredits = 26;
 * @return {number}
 */
proto.common.GetPackageStatusResponse.prototype.getPlancredits = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setPlancredits = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional int32 addonCredits = 27;
 * @return {number}
 */
proto.common.GetPackageStatusResponse.prototype.getAddoncredits = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setAddoncredits = function(value) {
  return jspb.Message.setProto3IntField(this, 27, value);
};


/**
 * optional bool isAddonPurchased = 28;
 * @return {boolean}
 */
proto.common.GetPackageStatusResponse.prototype.getIsaddonpurchased = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 28, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setIsaddonpurchased = function(value) {
  return jspb.Message.setProto3BooleanField(this, 28, value);
};


/**
 * optional bool isPaused = 29;
 * @return {boolean}
 */
proto.common.GetPackageStatusResponse.prototype.getIspaused = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.GetPackageStatusResponse} returns this
 */
proto.common.GetPackageStatusResponse.prototype.setIspaused = function(value) {
  return jspb.Message.setProto3BooleanField(this, 29, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.EstimateGenerationCreditsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.common.EstimateGenerationCreditsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.EstimateGenerationCreditsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.EstimateGenerationCreditsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    modelvariant: jspb.Message.getFieldWithDefault(msg, 1, ""),
    resolution: jspb.Message.getFieldWithDefault(msg, 2, ""),
    aspectratio: jspb.Message.getFieldWithDefault(msg, 3, ""),
    requesteddurations: jspb.Message.getFieldWithDefault(msg, 4, 0),
    segmentcount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    generatingcount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    inputmode: jspb.Message.getFieldWithDefault(msg, 7, ""),
    audiomode: jspb.Message.getFieldWithDefault(msg, 8, ""),
    prompttokens: jspb.Message.getFieldWithDefault(msg, 9, 0),
    inputimagetokens: jspb.Message.getFieldWithDefault(msg, 10, 0),
    cachedimagetokens: jspb.Message.getFieldWithDefault(msg, 11, 0),
    outputtokens: jspb.Message.getFieldWithDefault(msg, 12, 0),
    pricingflow: jspb.Message.getFieldWithDefault(msg, 13, 0),
    modelid: jspb.Message.getFieldWithDefault(msg, 14, 0),
    isclonead: jspb.Message.getBooleanFieldWithDefault(msg, 15, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.EstimateGenerationCreditsRequest}
 */
proto.common.EstimateGenerationCreditsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.EstimateGenerationCreditsRequest;
  return proto.common.EstimateGenerationCreditsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.EstimateGenerationCreditsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.EstimateGenerationCreditsRequest}
 */
proto.common.EstimateGenerationCreditsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelvariant(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setResolution(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAspectratio(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequesteddurations(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSegmentcount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGeneratingcount(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setInputmode(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAudiomode(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrompttokens(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setInputimagetokens(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCachedimagetokens(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOutputtokens(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPricingflow(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setModelid(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsclonead(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.EstimateGenerationCreditsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.EstimateGenerationCreditsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.EstimateGenerationCreditsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.EstimateGenerationCreditsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModelvariant();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResolution();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAspectratio();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRequesteddurations();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSegmentcount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getGeneratingcount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getInputmode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAudiomode();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPrompttokens();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getInputimagetokens();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getCachedimagetokens();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getOutputtokens();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getPricingflow();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getModelid();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getIsclonead();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
};


/**
 * optional string modelVariant = 1;
 * @return {string}
 */
proto.common.EstimateGenerationCreditsRequest.prototype.getModelvariant = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.EstimateGenerationCreditsRequest} returns this
 */
proto.common.EstimateGenerationCreditsRequest.prototype.setModelvariant = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string resolution = 2;
 * @return {string}
 */
proto.common.EstimateGenerationCreditsRequest.prototype.getResolution = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.EstimateGenerationCreditsRequest} returns this
 */
proto.common.EstimateGenerationCreditsRequest.prototype.setResolution = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string aspectRatio = 3;
 * @return {string}
 */
proto.common.EstimateGenerationCreditsRequest.prototype.getAspectratio = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.EstimateGenerationCreditsRequest} returns this
 */
proto.common.EstimateGenerationCreditsRequest.prototype.setAspectratio = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 requestedDurationS = 4;
 * @return {number}
 */
proto.common.EstimateGenerationCreditsRequest.prototype.getRequesteddurations = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.EstimateGenerationCreditsRequest} returns this
 */
proto.common.EstimateGenerationCreditsRequest.prototype.setRequesteddurations = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 segmentCount = 5;
 * @return {number}
 */
proto.common.EstimateGenerationCreditsRequest.prototype.getSegmentcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.EstimateGenerationCreditsRequest} returns this
 */
proto.common.EstimateGenerationCreditsRequest.prototype.setSegmentcount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 generatingCount = 6;
 * @return {number}
 */
proto.common.EstimateGenerationCreditsRequest.prototype.getGeneratingcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.EstimateGenerationCreditsRequest} returns this
 */
proto.common.EstimateGenerationCreditsRequest.prototype.setGeneratingcount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string inputMode = 7;
 * @return {string}
 */
proto.common.EstimateGenerationCreditsRequest.prototype.getInputmode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.EstimateGenerationCreditsRequest} returns this
 */
proto.common.EstimateGenerationCreditsRequest.prototype.setInputmode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string audioMode = 8;
 * @return {string}
 */
proto.common.EstimateGenerationCreditsRequest.prototype.getAudiomode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.EstimateGenerationCreditsRequest} returns this
 */
proto.common.EstimateGenerationCreditsRequest.prototype.setAudiomode = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 promptTokens = 9;
 * @return {number}
 */
proto.common.EstimateGenerationCreditsRequest.prototype.getPrompttokens = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.EstimateGenerationCreditsRequest} returns this
 */
proto.common.EstimateGenerationCreditsRequest.prototype.setPrompttokens = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 inputImageTokens = 10;
 * @return {number}
 */
proto.common.EstimateGenerationCreditsRequest.prototype.getInputimagetokens = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.EstimateGenerationCreditsRequest} returns this
 */
proto.common.EstimateGenerationCreditsRequest.prototype.setInputimagetokens = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 cachedImageTokens = 11;
 * @return {number}
 */
proto.common.EstimateGenerationCreditsRequest.prototype.getCachedimagetokens = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.EstimateGenerationCreditsRequest} returns this
 */
proto.common.EstimateGenerationCreditsRequest.prototype.setCachedimagetokens = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 outputTokens = 12;
 * @return {number}
 */
proto.common.EstimateGenerationCreditsRequest.prototype.getOutputtokens = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.EstimateGenerationCreditsRequest} returns this
 */
proto.common.EstimateGenerationCreditsRequest.prototype.setOutputtokens = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 pricingFlow = 13;
 * @return {number}
 */
proto.common.EstimateGenerationCreditsRequest.prototype.getPricingflow = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.EstimateGenerationCreditsRequest} returns this
 */
proto.common.EstimateGenerationCreditsRequest.prototype.setPricingflow = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 modelId = 14;
 * @return {number}
 */
proto.common.EstimateGenerationCreditsRequest.prototype.getModelid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.EstimateGenerationCreditsRequest} returns this
 */
proto.common.EstimateGenerationCreditsRequest.prototype.setModelid = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional bool isCloneAd = 15;
 * @return {boolean}
 */
proto.common.EstimateGenerationCreditsRequest.prototype.getIsclonead = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.EstimateGenerationCreditsRequest} returns this
 */
proto.common.EstimateGenerationCreditsRequest.prototype.setIsclonead = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.EstimateGenerationCreditsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.common.EstimateGenerationCreditsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.EstimateGenerationCreditsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.EstimateGenerationCreditsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    credits: jspb.Message.getFieldWithDefault(msg, 1, 0),
    originalcredits: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.EstimateGenerationCreditsResponse}
 */
proto.common.EstimateGenerationCreditsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.EstimateGenerationCreditsResponse;
  return proto.common.EstimateGenerationCreditsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.EstimateGenerationCreditsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.EstimateGenerationCreditsResponse}
 */
proto.common.EstimateGenerationCreditsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCredits(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOriginalcredits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.EstimateGenerationCreditsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.EstimateGenerationCreditsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.EstimateGenerationCreditsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.EstimateGenerationCreditsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCredits();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getOriginalcredits();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 credits = 1;
 * @return {number}
 */
proto.common.EstimateGenerationCreditsResponse.prototype.getCredits = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.EstimateGenerationCreditsResponse} returns this
 */
proto.common.EstimateGenerationCreditsResponse.prototype.setCredits = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 originalCredits = 2;
 * @return {number}
 */
proto.common.EstimateGenerationCreditsResponse.prototype.getOriginalcredits = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.EstimateGenerationCreditsResponse} returns this
 */
proto.common.EstimateGenerationCreditsResponse.prototype.setOriginalcredits = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


goog.object.extend(exports, proto.common);
